import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { EnvService, ApiMockService } from '../services';

@Injectable({ providedIn: 'root' })
export class HttpMockInterceptor implements HttpInterceptor {
  constructor(private envService: EnvService, private apiMockService: ApiMockService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.envService.api.useMock) {
      const response = this.apiMockService.handleRequest(request)?.pipe(
        map((evt) => {
          if (evt instanceof HttpResponse) {
            return evt.clone({ url: request.url });
          }
          return evt;
        })
      );
      return response || next.handle(request);
    }

    return next.handle(request);
  }
}
